// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"95a356d2","565":"53f49ee5","650":"1d92a0da","754":"280e5532"}[chunkId] + ".chunk.js";
};